import { Button, CircularProgress, Modal, Tooltip } from "@material-ui/core";
import { Typography } from "@mui/material";
import { ArrowsOut, CheckSquareOffset, Info, ListChecks } from "phosphor-react";
import React, { useEffect, useState } from "react";
import { fget } from "../../../../API/callsAPI";
import commonStyles from "../../../../Utils/commonStyles";
import { generateDateFormat } from "../../../../Utils/generateDateFormat";
import { TrackablesAndIcons } from "../../../Settings/Utility/TrackablesDetails";
import CustomDropdownTwo from "../../../Utilities/CustomDropdown/CustomDropdownTwo";
import ErrorOrSuccessMessage from "../../../Utilities/ErrorOrSuccessMessage/ErrorOrSuccessMessage.component";
import UsersViewer from "../../../Utilities/UsersViewer/UsersViewer";
import ExtendDeadlineModal from "../../UpdatePageModals/ExtendDeadlineModal";
import TodoExpandedViewModal from "../WidgetsModals/TodoExpandedViewModal";
import useStyles from "./DelayedTaskWidget.styles";

const DelayedTaskWidgetOverview = ({
  loggedInUser,
  projectId,
  users,
  projectDetails,
}) => {
  const classes = useStyles();
  const commonClasses = commonStyles();
  // const [selectedTrackable] = useState("all");
  const selectedTrackable = "all";
  const [isLoading, setIsLoading] = useState(true);
  const [taskList, setTaskList] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [statusList, setStatusList] = useState([]);
  // const [taskStatusFilter] = useState("delayed");
  const taskStatusFilter = "delayed";
  const [taskDepartmentFilter, setTaskDepartmentFilter] = useState("none");
  const [selectedUserFilter, setSelectedUserFilter] = useState("none");
  const [isAdmin, setIsAdmin] = useState(false);
  const [isExpandedViewOpen, setIsExpandedViewOpen] = useState(false);
  const [extendDeadlineModalData, setExtendDeadlineModalData] = useState({
    isOpen: false,
    data: {},
  });
  const [refreshCounter, setRefreshCounter] = useState(0);
  const [snackValue, setSnackValue] = useState({
    isOpen: false,
    message: "",
    isError: false,
  });

  const updateRefreshCounter = () => {
    setRefreshCounter(refreshCounter + 1);
  };

  const getTaskList = async () => {
    if (statusList?.length) {
      const filteredStatusIDs = statusList
        .filter((status) => {
          return (
            status.code === "IP" ||
            status.code === "WIP" ||
            status.code === "OPEN" ||
            status.code === "RVSN" ||
            status.code === "BLCK" ||
            status.code === "RTS"
          );
        })
        .map((status) => `&status=${status.id}`)
        .join("");
      const filterUrl = `trackables/task/?project=${projectId}&to=${`<${generateDateFormat(
        new Date()
      )}`}&assigned=${
        isAdmin ? 0 : 1
      }${filteredStatusIDs}&page=${1}&department=${
        taskDepartmentFilter === "none" ? "" : taskDepartmentFilter
      }&linked_class=${
        selectedTrackable === "all" || "Review" ? "" : selectedTrackable
      }${
        selectedUserFilter !== "none" && selectedTrackable !== "Review"
          ? `&assigned_users=${selectedUserFilter}`
          : ""
      }${
        selectedUserFilter !== "none" && selectedTrackable === "Review"
          ? `&reviewer=${selectedUserFilter}`
          : ""
      }`;
      try {
        const taskListRes = await fget({
          url: filterUrl,
        });
        const currentDate = new Date();
        if (taskStatusFilter === "all") {
          setTaskList(taskListRes?.data?.results);
        } else {
          const list = taskListRes?.data?.results?.filter((task) => {
            if (taskStatusFilter === "current") {
              return (
                new Date(task?.start_time) <= currentDate &&
                new Date(task?.end_time) >= currentDate
              );
            } else if (taskStatusFilter === "upcoming") {
              return new Date(task?.start_time) > currentDate;
            } else {
              return new Date(task?.end_time) < currentDate;
            }
          });
          setTaskList(list);
        }
        setIsLoading(false);
      } catch (error) {
        console.log(error);
        setIsLoading(false);
      }
    } else {
      setIsLoading(false);
    }
  };

  const getStatusList = async () => {
    try {
      const res = await fget({
        url: `trackables/status/?project=${projectId}`,
      });
      const taskStat = res?.data?.results?.filter((st) => {
        return st.status_class.includes(10);
      });
      setStatusList(taskStat);
    } catch (error) {
      console.log(error);
    }
  };

  const getDepartments = async () => {
    try {
      const res = await fget({ url: `department/?project=${projectId}` });
      const depts = res?.data?.results?.map((singDept) => {
        return { value: singDept?.id, title: singDept?.name };
      });
      setDepartments(depts);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getDepartments();
    getStatusList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const isUserAdmin = projectDetails?.admin_users?.some(
      (eachUser) => eachUser === loggedInUser?.id
    );
    setIsAdmin(isUserAdmin);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [projectDetails, loggedInUser]);

  useEffect(() => {
    if (loggedInUser) {
      setSelectedUserFilter(loggedInUser?.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loggedInUser]);

  useEffect(() => {
    setIsLoading(true);
    getTaskList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    taskDepartmentFilter,
    taskStatusFilter,
    statusList,
    selectedTrackable,
    selectedUserFilter,
    isAdmin,
    refreshCounter,
  ]);

  const closeExtendModal = () => {
    setExtendDeadlineModalData({
      isOpen: false,
      data: {},
    });
  };

  return (
    <div className={classes.root}>
      <ErrorOrSuccessMessage snackValue={snackValue} />
      <div className={classes.flexBetween}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            width: "100%",
          }}
        >
          <CheckSquareOffset size={22} />
          <Typography className={commonClasses.widgetsTitle}>
            Delayed Tasks
          </Typography>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
          }}
        >
          {/* <PencilLine size={20} color="gray" /> */}
          {/* <Trash size={20} color="gray" /> */}
          <Button
            onClick={() => setIsExpandedViewOpen(true)}
            style={{
              padding: 0,
            }}
          >
            <ArrowsOut size={20} />
          </Button>
        </div>
      </div>
      <div className={classes.dropdowns} style={{ marginTop: "10px" }}>
        <div style={{ width: "100%" }}>
          <CustomDropdownTwo
            name="Departments"
            value={taskDepartmentFilter}
            updateValue={(val) => setTaskDepartmentFilter(val)}
            options={departments}
            showNone={true}
          />
        </div>
        {isAdmin ? (
          <div style={{ width: "100%" }}>
            <CustomDropdownTwo
              name="Users"
              showNone={true}
              value={selectedUserFilter}
              updateValue={(val) => setSelectedUserFilter(val)}
              options={users?.map((user) => {
                return { value: user?.id, title: user?.name };
              })}
            />
          </div>
        ) : (
          ""
        )}
      </div>
      <div className={classes.taskListViewer2}>
        <div className={classes.taskCards}>
          {!isLoading ? (
            <>
              {taskList?.length > 0 ? (
                <>
                  {taskList?.map((task) => {
                    return (
                      <div className={classes.singleTaskCard} key={task?.id}>
                        <div
                          className={classes.flexBetween}
                          style={{
                            width: "100%",
                          }}
                        >
                          <div
                            style={{
                              width: "100%",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                              }}
                            >
                              <span
                                className={classes.statusColor}
                                style={{
                                  backgroundColor: `rgb(${task?.status?.color})`,
                                }}
                              />
                              <span
                                style={{
                                  fontSize: "12px",
                                }}
                              >
                                {task?.name ?? "No name"}
                              </span>
                            </div>
                          </div>
                          <div className={`${classes.flexAndGap}`}>
                            {/* <StatusViewer status={task?.status} /> */}
                            <div>
                              <UsersViewer
                                assignedUser={task?.assigned_users}
                                selectedTask={{
                                  assigned_users: task?.assigned_users,
                                }}
                                editable="no"
                              />
                            </div>
                            <div className={classes.todoCount}>
                              <ListChecks size={20} />
                              <span>--</span>
                            </div>
                            {/* <Button>
                              <DotsThree size={20} />
                            </Button> */}
                          </div>
                        </div>
                        <div
                          className={classes.flexBetween}
                          style={{
                            marginTop: "10px",
                            width: "100%",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "5px",
                              width: "100%",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              {
                                TrackablesAndIcons?.find(
                                  (track) =>
                                    track?.trackable === task?.linked_class
                                )?.icon
                              }
                            </div>
                            <Tooltip
                              title={
                                task?.linked?.name
                                  ? task?.linked?.name
                                  : task?.linked?.code
                              }
                            >
                              <Typography
                                sx={{
                                  textOverflow: "ellipsis",
                                  overflow: "hidden",
                                  whiteSpace: "nowrap",
                                  fontSize: "12px !important",
                                }}
                              >
                                {task?.linked?.name
                                  ? task?.linked?.name
                                  : task?.linked?.code}
                              </Typography>
                            </Tooltip>
                          </div>
                          <span
                            style={{
                              color:
                                taskStatusFilter === "all"
                                  ? "#FFFFFF"
                                  : taskStatusFilter === "current"
                                  ? "#87F056"
                                  : taskStatusFilter === "upcoming"
                                  ? "#5C9EFF"
                                  : "#FF0000",
                              minWidth: "110px",
                              fontSize: "12px",
                            }}
                          >
                            {new Intl.DateTimeFormat("en-US", {
                              day: "2-digit",
                              month: "short",
                            }).format(new Date(task?.start_time))}
                            -{" "}
                            {new Intl.DateTimeFormat("en-US", {
                              day: "2-digit",
                              month: "short",
                            }).format(new Date(task?.end_time))}
                          </span>
                        </div>
                      </div>
                    );
                  })}
                </>
              ) : (
                <div className={classes.flexCenter} style={{ height: "100%" }}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <Info size={40} color="#606479" />
                    <Typography
                      style={{
                        color: "#606479",
                        fontWeight: 500,
                        fontSize: "24px",
                        textAlign: "center",
                      }}
                    >
                      No Delayed Task Found
                    </Typography>
                  </div>
                </div>
              )}
            </>
          ) : (
            <div className={classes.flexCenter} style={{ height: "100%" }}>
              <CircularProgress
                type="Oval"
                color="secondary"
                height={50}
                width={50}
              />
            </div>
          )}
        </div>
      </div>
      <Modal
        open={extendDeadlineModalData.isOpen}
        className={classes.flexCenter}
        onClose={() => closeExtendModal()}
      >
        <ExtendDeadlineModal
          taskDetails={extendDeadlineModalData.data}
          closeModal={closeExtendModal}
          updateRefreshCounter={updateRefreshCounter}
          setSnackValue={setSnackValue}
        />
      </Modal>
      <Modal
        open={isExpandedViewOpen}
        onClose={() => setIsExpandedViewOpen(false)}
        className={classes.flexCenter}
      >
        <TodoExpandedViewModal
          handleClose={() => setIsExpandedViewOpen(false)}
          isDelayedTask={true}
          projectId={projectId}
          delayedFilter={statusList
            .filter((status) => {
              return (
                status.code === "IP" ||
                status.code === "WIP" ||
                status.code === "OPEN" ||
                status.code === "RVSN" ||
                status.code === "BLCK" ||
                status.code === "RTS"
              );
            })
            .map((status) => `&status=${status.id}`)
            .join("")}
        />
      </Modal>
    </div>
  );
};

export default DelayedTaskWidgetOverview;
